mutation SaveCustomerGuideDraft($input: CustomerGuideDraftInput!) {
  saveCustomerGuideDraft(input: $input) {
    conflict
    draft {
      draftId
      materialId
      sourcePublishedVersion
      revision
      status
      content
      updatedAt
    }
  }
}
